import { cn } from "@/lib/utils";
import { Stage } from "@/hooks/pipelines/usePipelines";

interface StageProgressBarProps {
  stages: Stage[];
  currentStageId: string;
}

export function StageProgressBar({ stages, currentStageId }: StageProgressBarProps) {
  // Filter to only OPEN stages (exclude WON/LOST)
  const openStages = stages
    .filter(
      (s) =>
        s.stage_type !== "WON" &&
        s.stage_type !== "LOST" &&
        !s.name?.toLowerCase().includes("ganho") &&
        !s.name?.toLowerCase().includes("perdido")
    )
    .sort((a, b) => a.stage_order - b.stage_order);

  if (openStages.length === 0) return null;

  const currentIndex = openStages.findIndex((s) => s.id === currentStageId);

  return (
    <div className="w-full py-2">
      <div className="flex items-center gap-0">
        {openStages.map((stage, index) => {
          const isPast = index < currentIndex;
          const isCurrent = index === currentIndex;
          const isActive = isPast || isCurrent;

          return (
            <div key={stage.id} className="flex items-center flex-1 min-w-0">
              {/* Dot */}
              <div className="flex flex-col items-center gap-1">
                <div
                  className={cn(
                    "h-2 w-2 rounded-full flex-shrink-0 transition-colors",
                    isActive ? "bg-primary" : "bg-muted-foreground/30"
                  )}
                />
                <span
                  className={cn(
                    "text-2xs truncate max-w-[60px] text-center leading-tight",
                    isCurrent
                      ? "font-semibold text-primary"
                      : "text-muted-foreground"
                  )}
                  title={stage.name}
                >
                  {stage.name}
                </span>
              </div>
              {/* Connector line */}
              {index < openStages.length - 1 && (
                <div
                  className={cn(
                    "h-0.5 flex-1 mx-1 transition-colors",
                    isPast ? "bg-primary" : "bg-muted-foreground/20"
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
